import { Component, Input, OnInit } from '@angular/core';
import { Settings } from 'src/app/shared-lib/core/settings';
import { ProductService } from 'src/app/shared-lib/domains/product';

@Component({
  selector: 'app-tooltip-info-binding',
  templateUrl: './tooltip-info-binding.component.html',
  styleUrls: ['./tooltip-info-binding.component.scss'],
  standalone: false
})
export class TooltipInfoBindingComponent implements OnInit {
  @Input() coverLaminated;
  @Input() settings;

  constructor(private productService: ProductService) {
  }

  ngOnInit() {
  }

  protected readonly Settings = Settings;

  getCurrentPaperWeight() {
    return this.settings[Settings.PAPER_WEIGHT].options[this.settings[Settings.PAPER_WEIGHT].selected - 1].value;
  }

  getSheetLimit() {
    return this.productService.getSheetLimit(this.getCurrentPaperWeight());
  }
}

